import React from 'react'
import { IssuingSpendingProfile } from './issuingSpendingProfile'

export const IssuingSpendingProfileAdd = () => {
  return (
    <IssuingSpendingProfile />
  )
}
